import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import LoginScreen from './components/auth/LoginScreen';
import ProtectedRoute from './components/auth/ProtectedRoute';
import Layout from './components/layout/Layout';
import Dashboard from './pages/Dashboard';
import EBooks from './pages/EBooks';
import EBookUpsert from './pages/EBookUpsert';
import Audio from './pages/Audio';
import AudioUpsert from './pages/AudioUpsert';
import Videos from './pages/Videos';
import VideoUpsert from './pages/VideoUpsert';
import Quotes from './pages/Quotes';
import QuoteUpsert from './pages/QuoteUpsert';
import Users from './pages/Users';
import Analytics from './pages/Analytics';
import ContentAnalytics from './pages/ContentAnalytics';
import Settings from './pages/Settings';
import FileUpload from './FileUpload';

// Placeholder components for other routes


const AppRoutes: React.FC = () => {
  const { user, isAdmin } = useAuth();

  return (
    <Routes>
      <Route
        path="/login"
        element={user && isAdmin ? <Navigate to="/" replace /> : <LoginScreen />}
      />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="ebooks" element={<EBooks />} />
        <Route path="ebooks/new" element={<EBookUpsert />} />
        <Route path="ebooks/:id/edit" element={<EBookUpsert />} />
        <Route path="ebooks/:id/view" element={<EBookUpsert />} />
        <Route path="audio" element={<Audio />} />
        <Route path="audio/new" element={<AudioUpsert />} />
        <Route path="audio/:id/edit" element={<AudioUpsert />} />
        <Route path="videos" element={<Videos />} />
        <Route path="videos/new" element={<VideoUpsert />} />
        <Route path="videos/:id/edit" element={<VideoUpsert />} />
        <Route path="videos/:id/view" element={<VideoUpsert />} />
        <Route path="quotes" element={<Quotes />} />
        <Route path="quotes/new" element={<QuoteUpsert />} />
        <Route path="quotes/:id/edit" element={<QuoteUpsert />} />
        <Route path="users" element={<Users />} />
        <Route path="analytics" element={<Analytics />} />
        <Route path="content-analytics" element={<ContentAnalytics />} />
        <Route path="settings" element={<Settings />} />
        <Route path="file-upload" element={<FileUpload />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

const App: React.FC = () => {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <AppRoutes />
          <Toaster
            position="top-right"
            toastOptions={{
              duration: 4000,
              style: {
                background: '#363636',
                color: '#fff',
              },
              success: {
                duration: 3000,
                iconTheme: {
                  primary: '#22c55e',
                  secondary: '#fff',
                },
              },
              error: {
                duration: 5000,
                iconTheme: {
                  primary: '#ef4444',
                  secondary: '#fff',
                },
              },
            }}
          />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
